import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-tennessee-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./tennessee-state-form.component.html",
  styleUrl: "./tennessee-state-form.component.scss",
})
export class TennesseeStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
